import Content from "./content";

export default class Admission extends Content {
	_build() {
		this._dom.container.classList.add("content-admission");
		this._dom.container.innerHTML = `<strong>${this._data.label}:</strong> ${this._data.value}`;
	}
}
